import { DOMAIN, LoggerFactory, FEATURE } from 'Services/Logger';

const logger = LoggerFactory.getLogger(DOMAIN.CONSUMER_ENABLEMENT);

export const createLog = (msg: string, params?: Record<string, unknown>) => {
  logger.info(msg, `${DOMAIN.CONSUMER_ENABLEMENT}.${FEATURE.LOGIN}`, {
    ...params,
  });
};

export const createErrorLog = (msg: string, error?: Record<string, unknown>) => {
  logger.error(msg, `${DOMAIN.CONSUMER_ENABLEMENT}.${FEATURE.LOGIN}`, {
    ...error,
  });
};
